import { CLEAN_MTOKNA_CAMPAIGN_TEMPLATE, FETCH_MTOKNA_CAMPAIGN_TEMPLATE } from '../actions/types';

const MTOKNA_CAMPAIGN_TEMPLATE_DEFAULT_STATE = {};

const MtoknaCampaignTemplateReducer = (state = MTOKNA_CAMPAIGN_TEMPLATE_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_CAMPAIGN_TEMPLATE:
            // Nacitanie sablony
            return payload;

        case CLEAN_MTOKNA_CAMPAIGN_TEMPLATE:
            // Vycistenie sablony
            return MTOKNA_CAMPAIGN_TEMPLATE_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaCampaignTemplateReducer;
